<ng-container *transloco="let t; read: 'comparison-filter-item.numeric-item'">
  <div class="comparison-filter-numeric-item__row">
    <ng-container
      *ngTemplateOutlet="operandTpl; context: { $implicit: displayValue?.leftOperand }"
    ></ng-container>

    @if (!isReadOnly && !displayValue?.booleanOperator) {
      <xi-default-button
        text="{{ t('and') }}"
        fill="no-fill"
        buttonSize="small"
        iconLeft="add_circle"
        [disabled]="!isBooleanOperatorEnabled"
        (onClick)="displayValue.booleanOperator = 'AND'"
      ></xi-default-button>
      <div class="comparison-filter-numeric-item__boolean-separator"></div>
      <xi-default-button
        text="{{ t('or') }}"
        fill="no-fill"
        buttonSize="small"
        iconLeft="add_circle"
        [disabled]="!isBooleanOperatorEnabled"
        (onClick)="displayValue.booleanOperator = 'OR'"
      ></xi-default-button>
    } @else {
      <span class="comparison-filter-numeric-item__boolean-operator">{{
        displayValue.booleanOperator
      }}</span>
    }
  </div>

  @if (displayValue?.booleanOperator) {
    <div class="comparison-filter-numeric-item__row">
      <ng-container
        *ngTemplateOutlet="operandTpl; context: { $implicit: displayValue?.rightOperand }"
      ></ng-container>
    </div>
  }

  <ng-template #operandTpl let-operand>
    <xi-dropdown
      #operatorDropdown
      placeholder="{{ t('placeholder') }}"
      [data]="arithmeticOperators"
      [value]="operand.operator"
      [disabled]="!isEnabled"
      [readOnly]="isReadOnly"
      (onValueChange)="onOperatorSet($event, operand)"
    ></xi-dropdown>

    <xi-input-field
      [(ngModel)]="operand.value"
      [disabled]="!isEnabled"
      [readOnly]="isReadOnly"
      type="number"
      (onChange)="onValueSet()"
    ></xi-input-field>
  </ng-template>
</ng-container>
